import React, { useState } from 'react';
import '../../style/caet/theme.scss';
import { ICaetBasic } from './interface';
import { useCertificateSvg } from './hook/useCertificateSvg';
import { classSet } from '@umu/umu-dom';
import { Modal } from '@umu/umu-design';
import { defaultConfig } from './dataFlow';
import { ReactSVG } from 'react-svg';
export interface IProps extends ICaetBasic {
    className?: string;
    children?: React.ReactNode;
    prohibitLink?: boolean;
}
const { confirm } = Modal;
const CaetThemeBasic = (props: IProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const {
        status,
        className = '',
        prohibitLink = false,
        config = defaultConfig,
        allowFullScreen = false,
        children = null,
        onClick,
        watermark = false,
        watermarkConfig,
    } = props;
    const { svgUrl, bindLinkEvents, grayscaleClass } = useCertificateSvg({
        status,
        config: config as unknown as Record<string, string>,
        watermark,
        watermarkConfig,
    });

    const handleSvgClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!svgUrl) {
            return;
        }
        if (onClick) {
            return onClick?.(e);
        } else {
            e.stopPropagation();
            allowFullScreen && caetFullScreen(svgUrl, prohibitLink ? undefined : bindLinkEvents);
        }
    };
    return (
        <div
            className={classSet({
                'ai-power-recognition-basic ratio-caet-img': true,
                [className]: !!className,
                [grayscaleClass]: !!grayscaleClass,
            })}
            onClick={handleSvgClick}
        >
            <ReactSVG
                src={svgUrl}
                className={`ai-power-recognition-basic-img ${svgUrl && isLoading ? 'hide' : ''}`}
                renumerateIRIElements={false}
                useRequestCache
                afterInjection={(svg) => {
                    !prohibitLink && bindLinkEvents(svg as unknown as HTMLElement);
                    if (svgUrl) {
                        setIsLoading(false);
                    }
                }}
            />
            {children}
        </div>
    );
};
const CaetThemeSkeleton = (props: { svgUrl: string; bindLinkEvents?: (element: HTMLElement) => void }) => {
    const { svgUrl, bindLinkEvents } = props;
    const [isLoading, setIsLoading] = useState(true);
    return (
        <div className="ratio-caet-img">
            <ReactSVG
                src={svgUrl}
                useRequestCache
                className={`ai-power-recognition-dialog-basic-img ${isLoading ? 'hide' : ''}`}
                renumerateIRIElements={false}
                afterInjection={(svg) => {
                    bindLinkEvents?.(svg as unknown as HTMLElement);
                    setIsLoading(false);
                }}
            />
        </div>
    );
};
const caetFullScreen = (svgUrl: string, bindLinkEvents?: (element: HTMLElement) => void) => {
    confirm({
        centered: true,
        closable: false,
        maskClosable: true,
        width: '9.6rem',
        footer: null, // 禁用默认按钮，自己控制
        className: 'full-screen-acet-preview-dialog',
        content: <CaetThemeSkeleton svgUrl={svgUrl} bindLinkEvents={bindLinkEvents} />,
    });
};
export { CaetThemeBasic };
